import React from 'react';
import classNames from 'classnames';
import { ReactComponent as CloseIcon } from 'assets/icons_3/x-close.svg';
import CloseButton from 'components/UI_kit_3/Button/CloseButton/CloseButton';
import ModalContext from '../modal-context';
import styles from './Modal.Header.module.scss';

export interface IModalHeaderProps
  extends React.PropsWithChildren<React.HTMLProps<HTMLDivElement>> {
  closeButton?: boolean;
}

const ModalHeader: React.FC<IModalHeaderProps> = ({
  closeButton,
  children,
  className,
  ...props
}) => {
  const context = React.useContext(ModalContext);

  const handleHide = () => {
    if (context?.onHide) {
      context?.onHide(false);
    }
  };

  return (
    <div
      className={classNames(styles.modalHeader, className, {
        [styles.hasCloseBtn]: closeButton,
      })}
      {...props}
    >
      <div className={styles.title}>{children}</div>
      {closeButton && (
        <CloseButton size="lg" className={styles.closeButton} onClick={handleHide} qa-element="modal-close">
          <CloseIcon />
        </CloseButton>
      )}
    </div>
  );
};

export default ModalHeader;
